<template>
    <div class="back-top">
        <span class="serve-icon relative" @mouseenter="serveShow" @mouseleave="serveHide">
            <i class="el-icon-headset"></i>
            <transition name="el-fade-in">
            <div v-if="isServe" class="code-list absolute">
                <ul class="flex justify-content">
                    <li v-if="this.$store.state.epServicePic">
                        <img :src="this.$store.state.epServicePic">
                        <p>{{this.$store.state.epServiceText}}</p>
                    </li>
                    <li v-if="this.$store.state.darenServicePic">
                        <img :src="this.$store.state.darenServicePic">
                        <p>{{this.$store.state.darenServiceText}}</p>
                    </li>
                </ul>
            </div>
            </transition>
        </span>
        <el-tooltip class="item" effect="dark" placement="left">
            <div slot="content">咨询热线：{{this.$store.state.cityTel}}</div>
            <el-button type="info" icon="el-icon-phone-outline" circle class="el-bt"></el-button>
        </el-tooltip>
        <el-button icon="el-icon-arrow-up" circle @click="backTop" :class="isShow === true ? 'show' :'hide'"></el-button>
    </div>
</template>
<script>
export default {
    name: 'BackTop',
    data () {
        return {
            isShow: false,
            isServe: false,
        }
    },
    methods: {
        handleScroll () {
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            scrollTop > 480 ? this.isWhite = true : this.isWhite = false;
            scrollTop > 480 ? this.isShow = true : this.isShow = false
        },
        backTop() {
            window.scrollTo(0,0);
        },
        serveShow () {
            this.isServe = true
        },
        serveHide () {
            this.isServe = false
        },
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll)
    },
    destroyed () {
        window.removeEventListener('scroll', this.handleScroll)
    }
}
</script>
<style scoped>
    .back-top{position: fixed;right:30px;bottom:30px;z-index: 99;width: 60px;height: 150px;}
    .serve-icon{width:40px;height: 40px;line-height:40px;background:#FF741F;display:block;border-radius: 50%;font-size: 14px;color:#fff;text-align: center;margin:10px;cursor:pointer;}
    .code-list{color:#333;bottom:0;right:45px;background: #fff;box-shadow: 0 0 10px rgba(0,0,0,.1);padding:10px;}
    .code-list ul li{width: 150px;}
    .code-list ul li img{width: 150px;}
    .code-list ul li p{line-height: 24px;}
    .hide{display: none;}
    .show{display: block;}
</style>
